import { STRING } from '@/plugins/sdk/fields'
import isString from 'lodash/isString'

export default {
  label: 'Begins with',
  operator: 'begins with',
  fields: [ STRING ],
  isValidValue (value) {
    return isString(value) && value.length
  }
}
